// Browser support is a property of this device, not the signed-in account.
export function extensionBrowserName(nav) {
  if (!nav) return null;
  const ua = nav.userAgent || '';
  if (nav.userAgentData?.mobile || /Android|Mobi|iPhone|iPad|iPod/i.test(ua)
      || (/Macintosh/i.test(ua) && nav.maxTouchPoints > 1)) return null;
  if (/Edg\//.test(ua)) return 'Edge';
  if (/OPR\/|Opera|SamsungBrowser|Vivaldi/i.test(ua)) return null;
  if (/Chrome\/|Chromium\//.test(ua)
      || nav.userAgentData?.brands?.some(({ brand }) => /^(Google Chrome|Chromium|Brave)$/.test(brand))) return 'Chrome';
  return null;
}
